import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { usePrevious } from '@cx-modules/hooks';
import { isTabletOrDesktopQuery } from '@cx-modules/react-utils';
import { getAllHeaderElementsHeight } from '@cx-modules/utils';

import { type MarketBet } from '../../../_common';

export interface useShowMoreProps {
  bets: MarketBet[];
  gridRef?: React.RefObject<HTMLDivElement | null>;
  maxMobileBets: number;
  maxTabletBets: number;
}

export const useShowMore = ({
  bets,
  gridRef,
  maxMobileBets,
  maxTabletBets,
}: useShowMoreProps): {
  handleShowMoreClick: () => void;
  hideShowMoreSection: boolean;
  showMore: boolean;
  showMoreText: string;
  visibleBets: MarketBet[];
} => {
  const isTabletOrDesktop = useMediaQuery(isTabletOrDesktopQuery);
  const showMoreMaxBets = isTabletOrDesktop ? maxTabletBets : maxMobileBets;

  const [showMore, setShowMore] = useState(false);
  const previousShowMore = usePrevious(showMore);

  const hideShowMoreSection = bets.length > showMoreMaxBets;

  const showMoreText = `Show ${showMore ? 'Less' : 'More'}`;

  const visibleBets = showMore ? bets : bets.slice(0, showMoreMaxBets);

  useEffect(() => {
    if (gridRef?.current && previousShowMore && !showMore) {
      const headerHeight = getAllHeaderElementsHeight();
      const { top } = gridRef.current.getBoundingClientRect();
      const y = top + window.pageYOffset - headerHeight - 62;
      typeof window !== 'undefined' && window.scrollTo({ behavior: 'smooth', top: y });
    }
  }, [gridRef, previousShowMore, showMore]);

  const handleShowMoreClick = () => {
    setShowMore(prev => !prev);
  };

  return {
    handleShowMoreClick,
    hideShowMoreSection,
    showMore,
    showMoreText,
    visibleBets,
  };
};
